<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">{{ $t('division.nameKh') }} </label>
        <input
          v-model="model.division_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('division_name_kh') }"
          :placeholder="$t('division.enterNameKh')"
        />
        <div class="invalid-feedback" v-if="errors.has('division_name_kh')">
          {{ errors.first('division_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('division.nameEn') }} <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.division_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('division_name_en') }"
          :placeholder="$t('division.enterNameEn')"
        />
        <div class="invalid-feedback" v-if="errors.has('division_name_en')">
          {{ errors.first('division_name_en') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'division-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        division_name_kh: '',
        division_name_en: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created() {
    this.setEdit()
  },
  computed: {},
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'division' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('division/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('division/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'division' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      ;(this.model.division_name_kh = ''), (this.model.division_name_en = '')
    }
  },
  watch: {
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
